import React from 'react';
import { Box } from '@chakra-ui/react';
import {
  HStack,
  Text,
} from '@ayble-health/dashboard-components';
import FlashIconSVG from '../CustomSVGs/FlashIconSVG';
import { AppointmentScheduler } from './AppointmentScheduler';
import CalendarSVG from '../CustomSVGs/CalendarSVG';
import { NextVisits } from './NextVisits';
import { useAppointmentsPage } from './hooks/useAppointmentsPage';
import { ProviderType } from '../../api/types';

type Props = {
  requestedProviderType: ProviderType | null;
  onRequestedProviderTypeHandled: () => void;
};

export const AppointmentsPage = ({
  requestedProviderType,
  onRequestedProviderTypeHandled,
}: Props) => {
  const {
    currentView,
    goToDatePicker,
    goToMeetingTypePicker,
    highlightMeetingId,
    highlightedMeetingId,
    selectedMeetingType,
    selectedProviderType,
  } = useAppointmentsPage();

  return (
    <Box>
      <HStack alignItems={'center'} px={6}>
        <FlashIconSVG />
        <Text
          color={'secondary.200'}
          fontSize={'md'}
          fontWeight={'normal'}
          ml={1}
        >
          Book New Appointment
        </Text>
      </HStack>

      <Box p={6}>
        <AppointmentScheduler
          currentView={currentView}
          goToDatePicker={goToDatePicker}
          goToMeetingTypePicker={goToMeetingTypePicker}
          highlightedMeetingId={highlightedMeetingId}
          key={highlightedMeetingId}
          requestedProviderType={requestedProviderType}
          selectedMeetingType={selectedMeetingType}
          selectedProviderType={selectedProviderType}
          onRequestedProviderTypeHandled={onRequestedProviderTypeHandled}
        />
      </Box>

      <HStack alignItems={'center'} p={6} pb={0}>
        <CalendarSVG />
        <Text
          color={'secondary.200'}
          fontSize={'md'}
          fontWeight={'normal'}
          ml={1}
        >
          Upcoming
        </Text>
      </HStack>

      <HStack
        overflow={'auto'}
        p={6}
        outlineColor={'transparent'}
        width={'100%'}
      >
        <NextVisits
          highlightedMeetingId={highlightedMeetingId}
          onRescheduleMeeting={(meetingType, providerType, meetingId) => {
            highlightMeetingId(meetingId);
            goToDatePicker(providerType, meetingType);
          }}
        />
      </HStack>
    </Box>
  );
};
